import React from 'react'
import {connect} from 'react-redux'
import {withSiteData} from 'react-static'
import {Modal, ModalHeader, ModalBody, ModalFooter, Button} from 'reactstrap';

import {createClient} from '../actions/clients'
import ClientForm from '../components/ClientForm'

class NewClientModal extends React.Component {
  constructor(props){
    super(props)
    this.state = {show: true}
  }

  close = () => this.setState({show: false})

  restoreUrl = () => {
    this.props.history.replace(this.props.backPath || '/clients')
  }

  handleSubmit = (values) => this.props.submit(values).then(this.close)

  render() {
    return(
      <Modal
        size='lg'
        backdrop="static"
        isOpen={this.state.show}
        toggle={this.close}
        onClosed={this.restoreUrl}>
        <ModalHeader toggle={this.props.close}>Neuer Kunde</ModalHeader>

        <ClientForm
          submit={this.handleSubmit}
          bodyComponent={ModalBody}
          buttonsComponent={({children}) =>
            <ModalFooter>
              {children}
              <Button color="secondary" onClick={this.close}>Abbrechen</Button>
            </ModalFooter>
          }/>
      </Modal>
    )
  }
}
export default connect(
  () => ({}),
  dispatch => ({
    submit: (payload) => dispatch(createClient(payload))
  })
)(withSiteData(NewClientModal))



// WEBPACK FOOTER //
// /Users/d064310/Development/playland/colorribbon/src/containers/NewClient.js